import { useCallback, useState } from "react";
import PdfViewerModal from "../../components/documents-tab/rental-financial-proposal/pdf-viewer-modal";

export function useProposalPreview() {
  const [open, setOpen] = useState(false);
  const [fileUrl, setFileUrl] = useState<string | undefined>();

  const showPreview = (url: string) => {
    setFileUrl(url);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setFileUrl(undefined);
  };

  const PreviewModal = useCallback(
    () => (
      <PdfViewerModal
        open={open}
        setOpen={setOpen}
        handleClose={handleClose}
        headerText="Your financial proposal is ready!"
        source={fileUrl}
        fileUrl={fileUrl}
      />
    ),
    [open, fileUrl]
  );

  return {
    showPreview,
    PreviewModal,
  };
}
